module.exports = __webpack_public_path__ + "img/pattern_3.7fff790e.png";